import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import IT from './translation/it/it.json';
import EN from './translation/en/en.json';

i18n
    //.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: EN
            },
            it: {
                translation: IT
            }
        },
        lng: "it",
        fallbackLng: "en",
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
